/** @format */

import React from 'react';

class Tooltip extends React.Component {
  constructor(props) {
    super(props);

    const initialDirection = this.props.direction || 'left';
    this.state = {
      direction: initialDirection,
      initialDirection
    };
    this.onMouseOver = this.onMouseOver.bind(this);
    this.onMouseOut = this.onMouseOut.bind(this);
  }

  onMouseOver() {
    if (this.state.directionChangeTimeout) {
      clearTimeout(this.state.directionChangeTimeout);
      this.setState({
        directionChangeTimeout: undefined
      });
    }
    const { offsetHeight: width, offsetHeight: height } = this.tooltip;
    const { left, top, right, bottom } = this.tooltip.getBoundingClientRect();
    if (left - width < 0) {
      this.setState({
        direction: 'right'
      });
    } else if (top - height < 0) {
      this.setState({
        direction: 'bottom'
      });
    } else if (right + width > window.innerWidth) {
      this.setState({
        direction: 'left'
      });
    } else if (bottom + height > window.innerHeight) {
      this.setState({
        direction: 'top'
      });
    }
  }

  onMouseOut() {
    const directionChangeTimeout = setTimeout(() => {
      this.setState({
        direction: this.state.initialDirection
      });
    }, 300);

    this.setState({
      directionChangeTimeout
    });
  }

  render() {
    const {
      children,
      content,
      maxWidth = 200,
      html = false,
      background,
      float = 'inherit'
    } = this.props;

    const direction = this.state.direction;
    const arrowStyle = {};
    arrowStyle[`border${capitalize(direction)}Color`] = background;

    return (
      <div
        style={{ float }}
        className='dualtech-tooltip-wrapper'
        ref={(ref) => (this.wrapper = ref)}
        onMouseOver={this.onMouseOver}
        onClick={(e) => e.stopPropagation()}
        onMouseOut={this.onMouseOut}
      >
        {children}
        <div
          className={`tooltip-wrapper-inner direction-${direction}`}
          style={{ width: `${maxWidth}px` }}
        >
          <div
            className={`tooltip direction-${direction}`}
            style={{ background: background }}
            ref={(ref) => (this.tooltip = ref)}
          >
            <span className='arrow' style={arrowStyle} />
            {html ? (
              <span dangerouslySetInnerHTML={{ __html: content }} />
            ) : (
              content
            )}
          </div>
          <div className='modal-background' onClick={this.onMouseOut} />
        </div>
      </div>
    );

    function capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }
}

export default Tooltip;
